function updateSellingPlan(
  fieldsetSelector,
  radioSelector,
  hiddenInputSelector,
  priceClasses,
  quantityInputSelectors
) {
  const fieldset = document.querySelector(fieldsetSelector);
  const radios = fieldset.querySelectorAll(radioSelector);
  const sellingPlanInput = document.querySelector(hiddenInputSelector);

  const priceEls = document.querySelectorAll(priceClasses);

  const quantityInputs = document.querySelectorAll(quantityInputSelectors);

  function updateInputValue() {
    let subRadioPrice = "";
    let oneTimePrice = "";
    if (radios.length > 0) {
      radios.forEach(function (radio) {
        if (radio.dataset.planOption !== "no_subscription") {
          subRadioPrice = radio.dataset.productPrice;
        }

        // console.log(subRadioPrice, radio.dataset.planOption);

        if (radio.dataset.planOption === "no_subscription") {
          oneTimePrice = radio.dataset.productPrice;
        }
      });
    }

    if (radios.length > 0) {
      radios.forEach(function (radio) {
        //console.log(radio.dataset.planOption);

        if (radio.checked) {
          console.log("strikethrough", oneTimePrice, radio.dataset.planOption);
          if (sellingPlanInput) {
            sellingPlanInput.value = radio.value;
          }

          if (priceEls.length > 0) {
            for (const priceEl of priceEls) {
              if (radio.dataset.planOption === "no_subscription") {
                priceEl.innerHTML = radio.dataset.productPrice;
              } else if (radio.dataset.planOption !== "no_subscription") {
                /*console.log(
                  "strikethrough",
                  oneTimePrice,
                  radio.dataset.planOption
                );*/
                priceEl.innerHTML = ` <span class="product-details__price--strikethrough" style="margin-right: 10px">${oneTimePrice}</span>${radio.dataset.productPrice}`;
              }
            }
          }

          quantityInputs.forEach(function (input) {
            if (radio.dataset.planOption !== "no_subscription") {
              input.classList.add("disabled");
            } else if (radio.dataset.planOption === "no_subscription") {
              input.classList.remove("disabled");
            }
          });
        }
      });
    }
  }

  // Run on page load
  updateInputValue();

  // Run on radio input change
  if (radios.length > 0) {
    radios.forEach(function (radio) {
      radio.addEventListener("change", updateInputValue);
    });
  }
}
